'use strict';

angular.module('substoreApp.services')
/**
 * return promise immediately. This is a convenience function simplifying
 * code which is urged to return promises but does not really need it
 */
    .service('promiseImmediately', ['$q', function ($q) {
        return function () {
            var deferred = $q.defer();
            var promise = deferred.promise;
            deferred.resolve();
            return promise;
        };
    }]);